<div class="community-translate" *transloco="let t">
  @if (offered()) {
    <div class="community-translate__bar d-flex align-items-center flex-wrap gap-2 mb-2">
      <div class="community-translate__dropdown btn-group" role="group">
        <!-- The main half is the one click a reader needs: translate, or flip
             back to the original; the caret keeps the per-language modes. -->
        @if (pending()) {
          <button type="button" class="btn btn-sm btn-outline-primary community-translate__main" disabled>
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            {{ t('community.translate.pending') }}
          </button>
        } @else if (hasTranslation()) {
          <button type="button" class="btn btn-sm community-translate__main"
                  [class.btn-primary]="showing()" [class.btn-outline-primary]="!showing()"
                  (click)="toggleShowing()">
            <span class="community-translate__icon" aria-hidden="true">🌐</span>
            {{ t(showing() ? 'community.translate.show_original' : 'community.translate.show_translation') }}
          </button>
        } @else if (failed() && canRetry()) {
          <button type="button" class="btn btn-sm btn-outline-warning community-translate__main" (click)="retry()">
            <span class="community-translate__icon" aria-hidden="true">🌐</span>
            {{ t('community.translate.retry') }}
          </button>
        } @else {
          <button type="button" class="btn btn-sm btn-outline-primary community-translate__main"
                  [disabled]="failed()" (click)="translateOnce()">
            <span class="community-translate__icon" aria-hidden="true">🌐</span>
            {{ t('community.translate.action') }}
            <span class="community-translate__codes">{{ sourceBadge() }} → {{ targetBadge() }}</span>
          </button>
        }
        <button type="button"
                class="btn btn-sm dropdown-toggle dropdown-toggle-split community-translate__caret"
                [class.btn-primary]="hasTranslation() && showing()" [class.btn-outline-primary]="!(hasTranslation() && showing())"
                [attr.aria-expanded]="menuOpen()"
                [title]="t('community.translate.badge_title', { lang: sourceLanguageName() })"
                (click)="toggleMenu($event)">
          <span class="visually-hidden">{{ t('community.translate.mode_label', { lang: sourceLanguageName() }) }}</span>
        </button>

        @if (menuOpen()) {
          <div class="dropdown-menu show community-translate__menu">
            @if (!hasTranslation()) {
              <button type="button" class="dropdown-item" [disabled]="pending()" (click)="translateOnce()">
                {{ t('community.translate.once') }}
              </button>
            } @else {
              <button type="button" class="dropdown-item" (click)="toggleShowing()">
                {{ t(showing() ? 'community.translate.show_original' : 'community.translate.show_translation') }}
              </button>
            }

            <div class="dropdown-divider"></div>

            <h6 class="dropdown-header">{{ t('community.translate.mode_label', { lang: sourceLanguageName() }) }}</h6>
            @for (m of modes; track m) {
              <button type="button" class="dropdown-item community-translate__mode" (click)="setMode(m)">
                <span class="community-translate__radio" aria-hidden="true">{{ mode() === m ? '●' : '○' }}</span>
                {{ t('community.translate.mode_' + m) }}
              </button>
            }
          </div>
        }
      </div>

      @if (showing()) {
        <span class="text-muted small">
          {{ t('community.translate.notice') }}
          <button type="button" class="btn btn-link btn-sm p-0 align-baseline community-translate__link" (click)="toggleShowing()">
            {{ t('community.translate.show_original') }}
          </button>
        </span>
      } @else if (failed()) {
        <span class="text-warning small d-inline-flex align-items-center gap-1">
          ⚠ {{ t(failureKey()) }}
        </span>
      }
    </div>
  }

  <div class="community-translate__body" [innerHTML]="displayBody | communityBody" appCommunityVideoEmbeds></div>
</div>
